export type FinanceTabId = "company" | "funnels" | "logistics" | "ads" | "reports";

interface FinanceTab {
  id: FinanceTabId;
  label: string;
}

interface FinanceTabsProps {
  tabs: FinanceTab[];
  activeTab: FinanceTabId;
  onChange: (tab: FinanceTabId) => void;
}

export const FinanceTabs = ({ tabs, activeTab, onChange }: FinanceTabsProps) => (
  <div className="flex w-fit max-w-full overflow-x-auto rounded-full bg-gray-200 p-1">
    {tabs.map((tab) => (
      <button
        id={`finance-tab-${tab.id}-target`}
        key={tab.id}
        onClick={() => onChange(tab.id)}
        className={
          activeTab === tab.id
            ? "inline-flex h-9 items-center justify-center whitespace-nowrap rounded-full bg-white px-6 text-sm font-semibold text-gray-900 shadow-sm transition"
            : "inline-flex h-9 items-center justify-center whitespace-nowrap rounded-full px-6 text-sm font-semibold text-gray-500 transition hover:text-gray-700"
        }
        type="button"
      >
        {tab.label}
      </button>
    ))}
  </div>
);
